import { useState } from "react";
import { ArrowLeft, ArrowUpRight, LockKeyhole } from "lucide-react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import SeoHead from "@/components/SeoHead";
import { useAuth } from "@/auth/AuthContext";

export default function Register() {
  const { user, register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  if (user) return <Navigate to="/insights" replace />;

  const submit = async (event) => {
    event.preventDefault();
    setSending(true);
    setError("");
    setMessage("");
    try {
      const data = await register(form.email, form.password, form.name);
      if (data.session) navigate("/insights", { replace: true });
      else setMessage("Check your email to confirm your account, then return here to sign in.");
    } catch (reason) {
      setError(reason.message);
    } finally {
      setSending(false);
    }
  };

  return (
    <main className="auth-page" data-testid="register-page">
      <SeoHead title="Create an account | Ashwini Patil" description="Create an account to save your own Decision Intelligence work." canonical="https://ashwinipatil.ai/register" noIndex schemas={[]} />
      <div className="shell auth-shell">
        <Link to="/login" className="inline-link" data-testid="register-back-link"><ArrowLeft size={15} /> Back to sign in</Link>
        <div className="auth-card">
          <div className="auth-mark"><LockKeyhole size={19} /></div>
          <div className="section-kicker">Reader account</div>
          <h1 className="auth-title">Make room for the work.</h1>
          <p className="auth-copy">Create a private account for the tools and working records behind the public catalogue.</p>
          <form onSubmit={submit} data-testid="register-form">
            <label className="form-field"><span className="form-label">Name</span><input className="form-input" type="text" value={form.name} onChange={(event) => setForm({ ...form, name: event.target.value })} required data-testid="register-name" /></label>
            <label className="form-field"><span className="form-label">Email</span><input className="form-input" type="email" value={form.email} onChange={(event) => setForm({ ...form, email: event.target.value })} required data-testid="register-email" /></label>
            <label className="form-field"><span className="form-label">Password</span><input className="form-input" type="password" minLength={12} value={form.password} onChange={(event) => setForm({ ...form, password: event.target.value })} required data-testid="register-password" /></label>
            <button type="submit" className="button-primary" disabled={sending} data-testid="register-submit">{sending ? "Creating…" : "Create account"} <ArrowUpRight size={15} /></button>
            <p className="auth-error" role="alert" data-testid="register-error">{error}</p>
            <p className="auth-success" role="status" data-testid="register-message">{message}</p>
          </form>
          <p className="auth-link-row">Already have an account? <Link to="/login" data-testid="register-login-link">Sign in</Link></p>
        </div>
      </div>
    </main>
  );
}
